import { render, staticRenderFns } from "./bindShop.vue?vue&type=template&id=5097b2d5&scoped=true"
import script from "./bindShop.vue?vue&type=script&lang=js"
export * from "./bindShop.vue?vue&type=script&lang=js"
import style0 from "./bindShop.vue?vue&type=style&index=0&id=5097b2d5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5097b2d5",
  null
  
)

export default component.exports